import { render, staticRenderFns } from "./BulkPrePulls.vue?vue&type=template&id=ed8b3840"
import script from "./BulkPrePulls.vue?vue&type=script&lang=js"
export * from "./BulkPrePulls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports